const {
  GET_INTERNAL_ACCOUNT_LIST,
  GET_INTERNAL_ACCOUNT_LIST_FAILED,
  GET_INTERNAL_ACCOUNT_LIST_SUCCESS,
  CREATE_INTERNAL_ACCOUNT,
  CREATE_INTERNAL_ACCOUNT_SUCCESS,
  CREATE_INTERNAL_ACCOUNT_FAILED,
  UPDATE_INTERNAL_ACCOUNT,
  UPDATE_INTERNAL_ACCOUNT_SUCCESS,
  UPDATE_INTERNAL_ACCOUNT_FAILED,
  GET_INTERNAL_ACCOUNT_DETAIL,
  GET_INTERNAL_ACCOUNT_DETAIL_SUCCESS,
  GET_INTERNAL_ACCOUNT_DETAIL_FAILED,
  RESET_INTERNAL_ACCOUNT_DETAIL,
  DELETE_INTERNAL_ACCOUNT,
  DELETE_INTERNAL_ACCOUNT_SUCCESS,
  DELETE_INTERNAL_ACCOUNT_FAILED,
} = require('./actionTypes');

const initialState = {
  isLoadingGetInternalAccountList: false,
  internalAccountList: [],
  internalAccountTotal: 0,
  isLoadingCreateInternalAccount: false,
  isLoadingUpdateInternalAccount: false,
  isLoadingGetInternalAccountDetail: false,
  isLoadingDeleteInternalAccount: false,
  internalAccountDetail: {},
};

const manageAccount = (state = initialState, action) => {
  switch (action.type) {
    case GET_INTERNAL_ACCOUNT_LIST:
      return {
        ...state,
        isLoadingGetInternalAccountList: true,
      };

    case GET_INTERNAL_ACCOUNT_LIST_SUCCESS:
      return {
        ...state,
        internalAccountList: action.payload.append
          ? [...state.internalAccountList, ...action.payload.data]
          : action.payload.data,
        internalAccountTotal: action.payload.total,
        isLoadingGetInternalAccountList: false,
      };

    case GET_INTERNAL_ACCOUNT_LIST_FAILED:
      return {
        ...state,
        isLoadingGetInternalAccountList: false,
      };

    case CREATE_INTERNAL_ACCOUNT:
      return {
        ...state,
        isLoadingCreateInternalAccount: true,
      };

    case CREATE_INTERNAL_ACCOUNT_SUCCESS:
    case CREATE_INTERNAL_ACCOUNT_FAILED:
      return {
        ...state,
        isLoadingCreateInternalAccount: false,
      };

    case UPDATE_INTERNAL_ACCOUNT:
      return {
        ...state,
        isLoadingUpdateInternalAccount: true,
      };

    case UPDATE_INTERNAL_ACCOUNT_SUCCESS:
    case UPDATE_INTERNAL_ACCOUNT_FAILED:
      return {
        ...state,
        isLoadingUpdateInternalAccount: false,
      };

    case GET_INTERNAL_ACCOUNT_DETAIL:
      return {
        ...state,
        isLoadingGetInternalAccountDetail: true,
      };

    case GET_INTERNAL_ACCOUNT_DETAIL_SUCCESS:
      return {
        ...state,
        internalAccountDetail: action.payload,
        isLoadingGetInternalAccountDetail: false,
      };

    case GET_INTERNAL_ACCOUNT_DETAIL_FAILED:
      return {
        ...state,
        isLoadingGetInternalAccountDetail: false,
      };

    case RESET_INTERNAL_ACCOUNT_DETAIL:
      return {
        ...state,
        internalAccountDetail: {},
        isLoadingGetInternalAccountDetail: false,
      };

    case DELETE_INTERNAL_ACCOUNT:
      return {
        ...state,
        isLoadingDeleteInternalAccount: true,
      };

    case DELETE_INTERNAL_ACCOUNT_SUCCESS:
    case DELETE_INTERNAL_ACCOUNT_FAILED:
      return {
        ...state,
        isLoadingDeleteInternalAccount: false,
      };

    default:
      return state;
  }
};

export default manageAccount;
